export default __webpack_public_path__ + "ffd312bed7cc248d879eac31605322c7.png";